import { Spinner } from "@heroui/react";
import React from "react";

function Loader({ small }: { small?: boolean }) {
  if (small) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-primary" /> */}
        <Spinner size="sm" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="flex justify-center">
        {/* <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary" /> */}
        <Spinner size="md" />
      </div>
    </div>
  );
}

export default Loader;
